<div class="container">
  <div class="container-content">
    <h2 class="title">{{ title }}</h2>
    <p class="description">{{ description }}</p>
    <div [id]="'identification_search_pet_' + tool" class="autocomplete">
      <rc-autocomplete
        [id]="'identification-search-pet'"
        (clear)="clearSearch()"
        (lastClickedItem)="didSelectSearch($event)"
        (searched)="onNewSearch($event)"
        [customFilter]="customSearchFilter"
        [emptyTemplate]="emptyTemplate"
        [itemSize]="itemSize"
        [itemHeight]="itemHeight"
        [items]="patients$ | async"
        [attr.data-testid]="'identification_search_pet'"
        [placeholder]="'searchbypo_or_pet' | translateKey"
        [showClear]="true"
        [showEmptyTemplate]="showEmptyResult$ | async"
        [showItemPrefix]="true"
        [valueAccessorFn]="valueAccessorFn"
      >
        <ng-template let-item>
          @if (item?.value?.pet?.speciesCode) {
            <app-icon
              [name]="item.value.pet.speciesCode === SpeciesCode.Dog ? IconName.specie_dog : IconName.specie_cat"
              class="specie-icon"
            ></app-icon>
          }
        </ng-template>
        <ng-template #emptyTemplate let-listItem>
          <div class="rc-autocomplete__list">
            <p class="rc-autocomplete__list__item empty-template" i18n="@@product-catalogue-empty_title_no_result">No result found</p>
            <rc-link
              [attr.data-qa]="'vs-' + tool + 'pet-identification-dropdown-button-create-new-pet'"
              class="rc-autocomplete__list__item empty-template-action"
              variant="secondary"
              size="large"
              iconname="user add"
              iconposition="left"
              (click)="createNewPet()"
            >
              {{ 'action_create-new-pet' | translateKey }}
            </rc-link>
          </div>
        </ng-template>
      </rc-autocomplete>
    </div>
    <div class="footer">
      <span class="footer-info" i18n="@@identification_not_registered"> Not registered yet ? </span>
      <rc-link
        [attr.data-qa]="'vs-' + tool + 'pet-identification-button-create-new-pet'"
        variant="secondary"
        size="large"
        (click)="createNewPet()"
      >
        {{ 'identification_start_new_pet' | translateKey }}
      </rc-link>
    </div>
  </div>
  <div class="container-image">
    @if (imgSrc) {
      <img [src]="imgSrc" class="image" loading="lazy" [alt]="'consultation_image_' + tool" />
    }
  </div>
</div>
